const getTypeRodadoByDomain = domain => {
  const patentsAuto = [
    { pattern: /^[A-Z]{3}\d{3}$/ },
    { pattern: /^[A-Z]{2}\d{3}[A-Z]{2}$/ },
    { pattern: /^[A-Z]{1}\d{3}[A-Z]{2}$/ }
  ];

  const patentsMoto = [
    { pattern: /^\d{3}[A-Z]{3}$/ },
    { pattern: /^[A-Z]{1}\d{3}[A-Z]{3}$/ }
  ];

  let isAuto = getType(patentsAuto, domain);

  let isMoto = getType(patentsMoto, domain);

  return {
      auto: isAuto,
      moto: isMoto
  }
};

const getType = (rules, value) => {
  const type = rules.filter(element => {
    return element.pattern.test(value && value.toUpperCase());
  });

  return type;
};

module.exports = {
  getTypeRodadoByDomain
};
